import { createContext } from 'react';

import { useAuthSession } from '../hooks/auth-session';

// ----------------------------------------------------------------------

export type AuthContextValue = ReturnType<typeof useAuthSession>;

export const AuthContext = createContext<AuthContextValue | undefined>(
  undefined,
);
